module.exports = function (done, value) {
  return { value: value, done: !!done };
};



// WEBPACK FOOTER //
// node_modules/_core-js@2.5.6@core-js/modules/_iter-step.js